import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestTcfVendorsGet = {
    path: "/tcf/vendors",
    method: RouteHttpVerb.GET
};
